// extracted by mini-css-extract-plugin
module.exports = {"root":"Lz4C85","link":"Er9M5V","label":"jCRPCc"};